export const EmployerActionTypes = {
  LOADING_REGISTER_USER: 'LOADING_REGISTER_USER',
  LOADING_EMPLOYER: 'LOADING_EMPLOYER',
  UPDATING_EMPLOYER: 'UPDATING_EMPLOYER',
  LOAD_EMPLOYER_START: 'LOAD_EMPLOYER_START',
  LOAD_EMPLOYER_SUCCESS: 'LOAD_EMPLOYER_SUCCESS',
  LOAD_EMPLOYER_FAILURE: 'LOAD_EMPLOYER_FAILURE',
  REGISTER_EMPLOYER_START: 'REGISTER_EMPLOYER_START',
  REGISTER_EMPLOYER_SUCCESS: 'REGISTER_EMPLOYER_SUCCESS',
  REGISTER_EMPLOYER_FAILURE: 'REGISTER_EMPLOYER_FAILURE',
  UPDATE_EMPLOYER_START: 'UPDATE_EMPLOYER_START',
  UPDATE_EMPLOYER_SUCCESS: 'UPDATE_EMPLOYER_SUCCESS',
  UPDATE_EMPLOYER_FAILURE: 'UPDATE_EMPLOYER_FAILURE',
  LOAD_LIST_EMPLOYER_START: 'LOAD_LIST_EMPLOYER_START',
  LOAD_LIST_EMPLOYER_SUCCESS: 'LOAD_LIST_EMPLOYER_SUCCESS',
  LOAD_LIST_EMPLOYER_FAILURE: 'LOAD_LIST_EMPLOYER_FAILURE',
  LOADING_LIST_EMPLOYER: 'LOADING_LIST_EMPLOYER',
};
